"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled = __importStar(require("./styled"));
const Typography_1 = __importStar(require("../../Typography"));
const CopyrightBlock = ({ copyright, color, copyrightInsideContainer }) => {
    var _a;
    return (react_1.default.createElement(styled.Container, { copyrightInsideContainer: copyrightInsideContainer },
        react_1.default.createElement(styled.Title, { type: Typography_1.Types.BODY_2, color: color }, copyright.title),
        react_1.default.createElement(styled.PoliciesContainer, null, (_a = copyright.policies) === null || _a === void 0 ? void 0 : _a.map((policy, index) => {
            return (react_1.default.createElement(react_1.default.Fragment, { key: policy === null || policy === void 0 ? void 0 : policy.title },
                react_1.default.createElement(Typography_1.default, { type: Typography_1.Types.BODY_2, color: color },
                    react_1.default.createElement(styled.Link, { href: policy === null || policy === void 0 ? void 0 : policy.href, target: "_blank" }, policy === null || policy === void 0 ? void 0 : policy.title)),
                index !== copyright.policies.length - 1 && react_1.default.createElement("span", null, "|")));
        }))));
};
exports.default = CopyrightBlock;
